import React from 'react';
import {
  SplitPotCharity,
  GrowingImpactCharity,
  AceOfHeartsCharity,
  GiftBoxCharity,
  SurvivorShieldCharity,
  CenterSquareCharity
} from './charity';

const THEME_COMPONENTS = {
  split_pot: SplitPotCharity,
  growing_impact: GrowingImpactCharity,
  ace_of_hearts: AceOfHeartsCharity,
  gift_box: GiftBoxCharity,
  survivor_shield: SurvivorShieldCharity,
  center_square: CenterSquareCharity
};

const DEFAULT_THEMES = {
  classic5050: 'split_pot',
  progressive5050: 'growing_impact',
  chaseTheAce: 'ace_of_hearts',
  prizeDraw: 'gift_box',
  eliminationDraw: 'survivor_shield',
  squareGame: 'center_square'
};

function getCharityComponent(theme, gameType) {
  const resolvedTheme = theme || DEFAULT_THEMES[gameType] || 'split_pot';
  return THEME_COMPONENTS[resolvedTheme] || SplitPotCharity;
}

export function CharityHeroStrip({ config = {}, gameType, gameData = {} }) {
  const { placement = 'hero_strip', theme } = config;

  if (placement !== 'hero_strip') {
    return null;
  }

  const CharityComponent = getCharityComponent(theme, gameType);
  const jackpot = gameData.jackpot || 0;

  return (
    <div className="w-full bg-gradient-to-r from-blue-50 via-white to-blue-50 dark:from-gray-800 dark:via-gray-900 dark:to-gray-800 border-b border-blue-100 dark:border-gray-700">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <CharityComponent jackpot={jackpot} variant="strip" />
      </div>
    </div>
  );
}

export function CharitySidebar({ config = {}, gameType, gameData = {} }) {
  const { placement = 'hero_strip', theme, showSidebar = true } = config;

  if (placement === 'hidden' || !showSidebar) {
    return null;
  }

  const CharityComponent = getCharityComponent(theme, gameType);
  const jackpot = gameData.jackpot || 0;

  return <CharityComponent jackpot={jackpot} variant="card" />;
}

export function CharityHeroIntegrated({ config = {}, gameType, gameData = {} }) {
  const { placement = 'hero_strip', theme } = config;

  if (placement !== 'hero_integrated') {
    return null;
  }

  const CharityComponent = getCharityComponent(theme, gameType);
  const jackpot = gameData.jackpot || 0;

  return <CharityComponent jackpot={jackpot} variant="integrated" />;
}

export default {
  CharityHeroStrip,
  CharitySidebar,
  CharityHeroIntegrated
};
